import React, { useEffect, useRef } from "react"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { Row, Col } from "antd"
import { IoCheckmarkDoneOutline } from "react-icons/io5"
import AOS from 'aos';

// Assets
import box2 from "../assets/icon/sidebar.png"
import box1 from "../assets/icon/about-icon.png"
import man from "../assets/About/menbook.png"
import blackshirt from "../assets/About/blackshirt.png"
import pinkshirt from "../assets/About/pinkshirt.png"
import circle from "../assets/About/circule.png"
import heart from "../assets/About/heart.png"

gsap.registerPlugin(ScrollTrigger)

function Aboutour() {
  const sectionRef = useRef(null)
  useEffect(() => {
    AOS.init({
      // Optional: Configuration options
      duration: 1000, // Animation duration
      easing: 'ease-in-out', // Easing function
      once: true, // Whether animation should happen only once - while scrolling down
    });
  }, []);
  useEffect(() => {
    let ctx = gsap.context(() => {
      // Animate text content
      gsap.from(".main-about", {
        opacity: 0,
        x: 80,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".main-about",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      })

      gsap.from(".main-about h1, .main-about p, .main-about ul li", {
        opacity: 0,
        y: 40,
        duration: 0.8,
        ease: "power2.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: ".main-about",
          start: "top 80%",
        },
      })

      // Animate hero images on scroll
      gsap.from(".hero-img", {
        opacity: 1,
        y: 80,
        scale: 1.5,
        duration: 1.2,
        ease: "power3.out",
        stagger: 0.3,
        scrollTrigger: {
          trigger: "#about-section",
          start: "top 20%",
        },
      })

      // Floating animation for hero images (infinite loop)
      gsap.utils.toArray(".float-item").forEach((el, i) => {
        gsap.to(el, {
          y: i % 2 === 0 ? 15 : -15,
          duration: 3 + i,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut",
        })
      })

      // Circle spins forever
      gsap.to(".circle-decor", {
        rotation: 360,
        duration: 12,
        repeat: -1,
        ease: "linear",
      })

      // ✅ Man image scales on scroll (GSAP ScrollTrigger only)
      gsap.fromTo(
        ".man-img",
        { scale: 0 },
        {
          scale: 1.5,
          duration: 2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: ".man-img",
            start: "top 80%",
            scrub: true,
          },
        }
      )
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (

    <div className="relative"  >
      <img src={box2} alt="" className=" hero-img absolute -right-0 top-80 w-100" />
      <div className="container">
        <Row
          gutter={[16]}
          className="container mx-auto"
          align="middle"
          justify="center"
          id="about-section"
          ref={sectionRef}
        >
          {/* LEFT SIDE HERO IMAGES */}
          <Col span={12}>

            <section className="relative flex justify-center items-center min-h-[90vh] bg-white">

              <div className="relative w-[850px] md:w-[400px] text-center">
                {/* ✅ Animate man with GSAP scaling */}
                <img
                  src={man}
                  alt="Main hero"
                  className="hero-img float-item man-img relative z-10 absolute -left-30 top-99 w-100"
                />

                {/* Other static elements */}
                <img
                  src={blackshirt}
                  alt="black shirt"
                  className="hero-img float-item absolute -left-24 top-20 w-100"
                />
                <img
                  src={pinkshirt}
                  alt="pink shirt"
                  className="hero-img float-item absolute -right-10 top-12 w-100"
                />
                <img
                  src={heart}
                  alt="heart"
                  className="hero-img absolute top-0 left-0 -bottom-10 w-100"
                />
                <img
                  src={circle}
                  alt="circle"
                  className="circle-decor absolute -right-0 top-[11px] bottom-16 w-100 opacity-70"
                />
              </div>
            <div className="mian-troper absolute bottom-40 border pt-2 pb-2 pl-2 pr-2">
              <p className="font-custom  text-[20px]"><span className="text-[25px]  font-custom text-[#95D8D1]   font-semibold pr-2 style-italic italic">25,000 +</span>Customer Worldwide</p>
            </div>
            </section>
          </Col>

          {/* RIGHT SIDE TEXT CONTENT */}
          <Col span={12}>
            <div className="main-about">
              <p className="text-sm font-medium text-[25px] text-black mb-2 font-custom">
                <span className="text-[#6cc5bf] text-4xl">_</span> About Our Company
              </p>
              <h1 className="text-4xl md:text-6xl font-bold text-black font-custom leading-snug md:leading-[1.3]">
                High Quality{" "}
                <span className="text-[#6cc5bf] inline-block pr-3">Printing</span>
                Service In California
              </h1>
              <p className="font-outfit w-[80%] text-gray-700 mt-4 text-lg font-light">
                Your T-Shirt Is More Than Just Fabric — It’s A Canvas For Your
                Ideas, Your Brand, And Your Story. At Initial Global Trade, We
                Make It Easy To Create Custom T-Shirts That Stand Out With Bold
                Colors, Durable Prints, And Endless Design Possibilities.
              </p>

              {/* Features */}
              <ul className="flex items-center gap-6 mt-5">
                <li className="flex items-center gap-5">
                  <img className="w-12" src={box1} alt="icon" />
                  <div>
                    <h4 className="font-outfit text-xl">T-Shirt Printing</h4>
                    <p className="font-custom text-sm text-black">
                      Attract relevant users using specific hashtags.
                    </p>
                  </div>
                </li>

                <li className="flex items-center gap-5">
                  <img className="w-12" src={box1} alt="icon" />
                  <div>
                    <h4 className="font-outfit text-xl">Customized T-Shirt Printing</h4>
                    <p className="font-custom text-sm text-black">
                      Attract relevant users using specific hashtags.
                    </p>
                  </div>
                </li>
              </ul>

              <div className="mian-about-li">
                <ul className="flex items-center gap-10 mt-5">
                  <li className="flex items-center gap-1 font-custom">
                    <span>
                      <IoCheckmarkDoneOutline className="text-[#6cc5bf]" />
                    </span>{" "}
                    <p>Large print & stock selection & Unique Print</p>
                  </li>
                  <li className="flex items-center gap-1 font-custom">
                    <span>
                      <IoCheckmarkDoneOutline className="text-[#6cc5bf]" />
                    </span>{" "}
                    <p>Large print & stock selection & Unique Print</p>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Aboutour
